import React, { useEffect, useState } from 'react';
// @mui
import { styled } from '@mui/material/styles';

// 다국어
import { useTranslation } from 'react-i18next';
// Mui table
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import axios from 'axios';

import DashGroupTB from './TableComponent/DashGroupTB';
import ProfileComponent from './ProfileComponent';

const StyledDiv = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '40px',
}));

const StyledDiv2 = styled('div')(() => ({
  backgroundColor: 'white',
  marginRight: '40px',
  padding: '30px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '10px',
  width: '20rem',
  height: '21rem',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
}));

const StyledDiv3 = styled('div')(() => ({
  backgroundColor: 'white',
  padding: '56px',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  borderRadius: '10px',
  flex: 1,
}));

const StyledTableCell = styled(TableCell)(() => ({
  backgroundColor: 'white',
  borderTop: '1px solid #ddd',
  borderBottom: '1px solid #ddd',
  color: 'black',
}));

export default function MypageDashBoard({ data }) {
  // 다국어
  const { t, i18n } = useTranslation(['page']);

  useEffect(() => {
    const userData = JSON.parse(sessionStorage.getItem('login_info'));
    // 데이터 체크
    if (userData !== null) {
      axios
        .post(`${process.env.REACT_APP_SERVER_URL}/user/regist/${userData.user_token}`)
        .then((response) => {
          //   console.log("유저 데이터 불러오기 response", response.data[0][0])
          if (!isEmptyArr(response.data[0])) {
            setAxiosData(response.data[0][0]);

            // setLicenseType(response.data[0][0].type);

            // 라이센스 타입별 사용횟수 검색
            axios({
              url: `${process.env.REACT_APP_SERVER_URL}/user/license-type/${response.data[0][0].type}`,
              method: 'post',
            })
              .then((response) => {
                // console.log("라이센스 타입 response", response.data[0][0])
                if (Object.prototype.hasOwnProperty.call(response.data[0][0], 'license_type_setting_json')) {
                  // console.log("라이센스 타입 json ", response.data[0][0])
                  // console.log("라이센스 타입 response", JSON.parse(response.data[0][0].license_type_setting_json))
                  setLicenseTypeUseInfo(JSON.parse(response.data[0][0].license_type_setting_json));
                }
              })
              .catch((response) => {
                console.log(response);
              });
          } else if (isEmptyArr(response.data[0])) {
            setAxiosData({
              user_email: '',
              org_id: '',
              org_authority: '',
              org_status: 0,
              organization_name: '',
              organization_created_at: '',
              license_type: 'no license',
              type: 'no license',
              license_due_date: null,
              license_enable: null,
              license_created_at: null,
              use_receipt_cnt: 0,
              available_receipt_cnt: 0,
              use_bill_cnt: 0,
              available_bill_cnt: 0,
              use_customer_cnt: 0,
              available_customer_cnt: 0,
              use_member_cnt: 0,
              available_member_cnt: 0,
              start_date: '',
              end_date: '',
            });
          }
        })
        .catch((response) => {
          console.log(response);
        });

      const sendData = {
        user_token: userData.user_token,
        month_count: 0,
      };

      axios({
        url: `${process.env.REACT_APP_SERVER_URL}/user/amount-used`,
        method: 'post',
        data: sendData,
      })
        .then((response) => {
          const newUserList = [];
          if (Object.prototype.hasOwnProperty.call(response.data[0][0], 'type')) {
            for (let i = 0; i < response.data[0].length; i += 1) {
              newUserList.push({
                type: response.data[0][i].type,
                count: response.data[0][i].count,
                last_date: response.data[0][i].last_date,
                start_date: response.data[0][i].start_date,
              });
            }

            if (!isEmptyArr(newUserList)) {
              setAmountUsedList(newUserList);
              setUsedListNull(false);
            } else {
              setUsedListNull(true);
            }
          }
        })
        .catch((response) => {
          console.log(response);
        });

      // if (response.data.hasOwnProperty('keyName')) {
      //     const value = response.data.keyName;
      //     // 사용할 코드
      //   }

      // console.log("as",amountUsedList)
    }
  }, []);

  const UserData = data;
  const [axiosData, setAxiosData] = useState([]);
  const [amountUsedList, setAmountUsedList] = useState([]);
  const [usedListNull, setUsedListNull] = useState(true);
  const [licenseTypeUseInfo, setLicenseTypeUseInfo] = useState([]);

  // 들어온 배열이 빈값인지 확인하는 함수----------------------------------

  function isEmptyArr(arr) {
    if (Array.isArray(arr) && arr.length === 0) {
      return true;
    }
    return false;
  }

  // -------------------------------------------------------------------

  // 테이블 만들기
  function createData(plan, receipt, bill, vendors, groupMember, startDate, endDate) {
    return { plan, receipt, bill, vendors, groupMember, startDate, endDate };
  }

  // const rows = [
  //     createData(`${axiosData.license_type}`,
  //         `${amountUsedList[0].count}건/${axiosData.available_receipt_cnt}건`,
  //         `${amountUsedList[1].count}건/${axiosData.available_bill_cnt}건`,
  //         `${amountUsedList[2].count}개/${axiosData.available_customer_cnt}개`,
  //         `${axiosData.use_member_cnt}명/${axiosData.available_member_cnt}명`,
  //         `${axiosData.start_date}`,
  //          `${axiosData.last_date}`),
  // ];
  // if (amountUsedList.length > 0 && amountUsedList[0] != null) {
  //     console.log(amountUsedList);
  //   } else {
  //     console.log("amountUsedList is empty or undefined");
  //   }
  // console.log(axiosData);
  console.log(amountUsedList);
  return (
    <div style={{ display: 'flex', padding: '0 10%' }}>
      <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        <StyledDiv>
          <StyledDiv2>
            <ProfileComponent data={UserData} />
          </StyledDiv2>
          <StyledDiv3>
            <h2>
              {t('현재')}{' '}
              <span style={{ color: 'rgb(26, 158, 248)' }}>
                {axiosData.license_type === 'no license' ? null : t(axiosData.license_type)}
              </span>
              {axiosData.license_type === 'no license'
                ? t('이용중인 라이센스가 없습니다.')
                : t('라이센스 이용중입니다.')}
            </h2>
            <div>
              <span style={{ marginRight: '10px', fontWeight: '600', fontSize: 'larger' }}>
                {axiosData.license_type === 'no license'
                  ? t('지금 무료로 시작해보세요!')
                  : `${t(axiosData.license_type)} : `}
              </span>
              <span>
                {axiosData.license_type === 'no license' ? null : axiosData.license_type === '레인드롭 무료 플랜' ? (
                  <>{axiosData.license_created_at} ~ </>
                ) : (
                  <>
                    {axiosData.license_created_at} ~ {axiosData.license_due_date}
                  </>
                )}
              </span>
            </div>
            <TableContainer component={Paper} style={{ borderRadius: 0 }}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center">{t('플랜')}</StyledTableCell>
                    <StyledTableCell align="center">{t('접수')}</StyledTableCell>
                    <StyledTableCell align="center">{t('청구서')}</StyledTableCell>
                    {/* <StyledTableCell align="center">거래처</StyledTableCell> */}
                    <StyledTableCell align="center">{t('구성원')}</StyledTableCell>
                    <StyledTableCell align="center">{t('기간')}</StyledTableCell>
                  </TableRow>
                </TableHead>
                {axiosData.license_type === 'no license' ? null : (
                  <TableBody style={{ borderBottom: '1px solid #ddd' }}>
                    <TableRow key={axiosData.license_type} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                      <TableCell align="center" component="th" scope="row">
                        <span
                          style={{ backgroundColor: '#1A9EF8', borderRadius: '5px', color: '#fff', padding: '0.4rem' }}
                        >
                          {axiosData.license_type === 'no license' ? null : t(axiosData.license_type)}
                        </span>
                      </TableCell>
                      <TableCell align="center">
                        {amountUsedList[0] != null && amountUsedList[0].count != null ? amountUsedList[0].count : 0}{' '}
                        {t('건')}/{licenseTypeUseInfo.receipt_cnt} {t('건')}
                      </TableCell>
                      <TableCell align="center">
                        {amountUsedList[1] != null ? amountUsedList[1].count : 0} {t('건')}/
                        {licenseTypeUseInfo.bill_cnt} {t('건')}
                      </TableCell>
                      {/* <TableCell align="center">{row.vendors}</TableCell> */}
                      <TableCell align="center">
                        {axiosData.use_member_cnt}
                        {t('명')}
                      </TableCell>
                      <TableCell align="center">
                        {axiosData.start_date}
                        <br />
                        {axiosData.end_date}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </StyledDiv3>
        </StyledDiv>
        <StyledDiv3>
          {axiosData.organization_name && (
            <>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                <h2>{axiosData.organization_name}</h2>
                <span
                  style={{
                    backgroundColor: '#1A9EF8',
                    borderRadius: '5px',
                    color: '#fff',
                    padding: '0.2rem 0.4rem',
                    width: 'fit-content',
                    height: 'fit-content',
                    marginLeft: '10px',
                  }}
                >
                  {axiosData.org_authority}
                </span>
              </div>
              <DashGroupTB data={axiosData.org_id} />
            </>
          )}
        </StyledDiv3>
      </div>
    </div>
  );
}
